var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"incite-wrapper",class:{ visible: _vm.visible }},[_c('div',{staticClass:"incite"})])}
var staticRenderFns = []

export { render, staticRenderFns }